import useSWR, { useSWRConfig } from 'swr';
import { get, put, post, patch } from 'api/api';
import { usePaginatedFetch } from 'utils/sdk';

const getActiveStores = (stores) => stores?.filter((item) => item.isActive === true);

export function useOwnerDetails(itemId) {
  const { mutate } = useSWRConfig();
  const key = itemId ? `/services/owner/${itemId}/detail/` : undefined;
  const { data, error } = useSWR(key, get);

  return {
    data: {
      ...data?.data,
      stores: getActiveStores(data?.data?.stores),
    },
    invalidate: () => {
      mutate(key);
    },
    isLoading: !error && !data,
    isError: error,
  };
}

export function updateOwner(values) {
  const url = `/services/owner/${values.id}/`;
  return patch(url, values);
}

export function changePassword(params) {
  const url = '/services/user/current/passwordchange/';
  return put(url, params);
}

export function closeTutorial(ownerId) {
  const url = `/services/owner/${ownerId}/`;
  return patch(url, { hasClosedTutorial: true }, { f2bDict: ownerF2BDict });
}

const ownerF2BDict = {
  actor: {
    firstName: 'first_name',
    lastName: 'last_name',
  },
  hasClosedTutorial: 'has_closed_tutorial',
};

export function getStoreList(ownerId) {
  const { mutate } = useSWRConfig();
  const url = ownerId ? `/services/owner/${ownerId}/stores/` : undefined;
  const { data, error } = useSWR(url, get);
  return {
    data: {
      ...data?.data,
      stores: getActiveStores(data?.data?.stores),
    },
    invalidate: (newData, forceRequest) => {
      mutate(url, newData, forceRequest);
    },
    isLoading: !error && !data,
    isError: error,
  };
}

export function useStoreListPaginated() {
  const { mutate } = useSWRConfig();
  const storesUrl = `services/owner/stores/list/`;

  const { data, isLoading, currentPage, count, setPage } = usePaginatedFetch({
    url: storesUrl,
    params: { limit: 50 },
  });

  return {
    data,
    isLoading,
    currentPage,
    count,
    setPage,
    invalidate: (newData, forceRequest) => {
      mutate(storesUrl, newData, forceRequest);
    },
  };
}

export function ownerSetLocalProducts(payload) {
  const url = `/services/owner/set-local-products/`;
  return post(url, payload);
}

export function getStoreDropdownList() {
  const { mutate } = useSWRConfig();

  const url = '/services/owner/stores/dropdown/';

  const { data, error } = useSWR(url, get);

  return {
    data: data?.data ?? [],
    invalidate: (newData, forceRequest) => {
      mutate(url, newData, forceRequest);
    },
    isLoading: !error && !data,
    isError: error,
  };
}
